<template>
  <div
    class="commonBlueButton"
    @click="click"
  >
    <span>{{ content }}</span>
  </div>
</template>

<script>
export default {
  name: 'CommonBlueButton',
  components: {},
  props: {
    content: { type: String, default: '按钮' }
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    click() {
      this.$emit('click');
    }
  }
};
</script>

<style scoped lang="scss">
.commonBlueButton {
  background: #2f58fe;
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  //line-height: 40px;
  text-align: center;
  width: 100px;
  height: 40px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    background: #3e7eff;
  }
}
</style>
